interface LogoProps extends React.HTMLAttributes<SVGElement> {
  color?: string
  gradient?: boolean | string
  width?: number
}

export default function Logo({
  color = '#000000',
  gradient = true,
  id = 'main',
  width = 50,
  ...props
}: LogoProps) {
  const gradientId = `logo-gradient-${id}`

  const logoMarkFill =
    typeof gradient === 'string'
      ? gradient
      : gradient
        ? `url(#${gradientId})`
        : color

  return (
    <svg
      width={width}
      height='40'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 238.4 153.73'
      {...props}
    >
      <path
        d='M50.24,1.1c15.46,0,30.93,0,46.39,0a2.88,2.88,0,0,1,2.73,1.5q17,26.93,34.05,53.81c1.07,1.68,1,2.1-.53,3.42q-21.31,18.5-42.65,37a3.91,3.91,0,0,1-2.22.88c-11.54.44-23.08.8-34.62,1.19-2.35.08-4.71.2-7.07.22-1.22,0-1.7.75-2.15,1.72q-11,23.83-22,47.65c-.77,1.66-1.55,3.32-2.3,5-.4.9-1,1.48-2,1.24s-1.22-1-1.22-1.91q0-37.14,0-74.29a3.07,3.07,0,0,1,.75-1.89Q29.6,63.52,41.85,50.53a1.81,1.81,0,0,1,2.1-.7c.9.35,1,1.14,1,2,0,5.55,0,11.1,0,16.65,0,1.84.55,2.32,2.39,2.25,8.62-.3,17.24-.61,25.87-.84,5-.14,5-.08,8.71-3.33l14.3-12.41c1.21-1,1.3-1.53.45-2.86-4.35-6.88-8.73-13.74-13-20.64a2.53,2.53,0,0,0-2.53-1.15c-20.62,0-41.24,0-61.86.05a3.82,3.82,0,0,1-3.87-2.22C11,19.65,6.52,12.05,2.09,4.43,1.64,3.65,1,2.89,1.6,1.9s1.57-.8,2.48-.8Z'
        fill={logoMarkFill}
      />
      <path
        d='M175.39,1.11h62.72c.44,0,1.19-.08,1.55.82a2.1,2.1,0,0,1-.7,2.18c-3.31,3.24-6.59,6.51-9.89,9.77-4.89,4.83-9.79,9.64-14.66,14.49a3.49,3.49,0,0,1-2.73,1.15c-7.64,0-15.27,0-22.9,0-2,0-2.39.37-2.39,2.37,0,3.87.05,7.75,0,11.62a3.52,3.52,0,0,1-.87,2.19Q173.42,58,161.29,70.3c-.61.61-1.19,1.22-2.18.81s-1-1.2-1-2.09q0-18.57,0-37.14c0-2-.39-2.38-2.38-2.38-8.75,0-17.5,0-26.25,0A2.85,2.85,0,0,1,126.74,28c-5-7.92-10.07-15.82-15.11-23.73-.44-.69-1-1.37-.52-2.29s1.4-.91,2.29-.91Q144.39,1.13,175.39,1.11Z'
        fill={logoMarkFill}
      />
      <path
        d='M158.85,88l-1.22,1.12-67.32,64.5a5,5,0,0,1-1.42,1,2.27,2.27,0,0,1-2.74-.89,2.72,2.72,0,0,1,.49-3.18,6.67,6.67,0,0,1,.6-.59l94.05-90.81c1-1,1.91-1.94,2.86-2.91.56-.57,1.16-1,2-.6a1.72,1.72,0,0,1,1,1.87c-.16,15.77-.42,31.55-.38,47.32a7.66,7.66,0,0,1-3.63,7.14c-7.22,5.07-14.19,10.48-21.26,15.76a1.42,1.42,0,0,1-.39.28c-.7.16-1.52.57-2.06.34a2.25,2.25,0,0,1-.82-1.77c0-5,0-10.06,0-15.09q.1-11.08.22-22.16Z'
        fill={logoMarkFill}
      />

      {gradient === true && (
        <defs>
          <linearGradient
            id={gradientId}
            x1='10.5594'
            y1='-6.43198'
            x2='32.5851'
            y2='67.2092'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#27B1C6' />
            <stop offset='1' stopColor='#59CDA1' />
          </linearGradient>
        </defs>
      )}
    </svg>
  )
}
